import { connect } from 'react-redux';
import { NoSearchResults } from "./NoSearchResults";
import { getNoSearchResultsContent } from "../../../store/content/selectors";

const mapStateToProps = state => {  
  return ({
    content: getNoSearchResultsContent(state),
  });
};

export const NoSearchResultsContainer = connect(
  mapStateToProps,  
)(NoSearchResults);
